import { z } from 'zod'
import { objectToSnake } from 'ts-case-convert'
import { API, handleFormError } from './api'
import { searchSchema, searchTypeSchema } from './schemas'

//* ---------------- APIS ---------------- *//
export async function getSearches(rawParams: Record<string, unknown>) {
  try {
    const params = getSearchesParamsSchema.parse(rawParams)
    const response = await API.get('searches', { params })
    const searches = z.array(searchSchema).parse(response.data)

    return searches
  } catch (error) {
    return handleFormError(error, 'Searches')
  }
}

//* ---------------- PARAMS ---------------- *//
const getSearchesParamsSchema = z
  .object({
    q: z.string(),
    filters: z.array(searchTypeSchema).optional(),
    dealer_id: z.coerce.number().optional(),
  })
  .transform(objectToSnake)
//* ---------------- HELPERS ---------------- *//
